import { useSliderLayout } from '../hooks/useSliderLayout';

const Slide = ({ children, slideWidth = '100%', centerMode, centerModeSlidesGap, slidesPerPage }: any) => {
	const { blockClass } = useSliderLayout();
	const slideContainerStyles = {
		width: `${slideWidth}%`,
		marginLeft: centerMode !== 'disabled' && !centerModeSlidesGap ? `${slideWidth / (8 * slidesPerPage)}%` : undefined,
		marginRight: centerMode !== 'disabled' && !centerModeSlidesGap ? `${slideWidth / (8 * slidesPerPage)}%` : undefined,
		paddingLeft: centerMode !== 'disabled' && centerModeSlidesGap ? centerModeSlidesGap / 2 : undefined,
		paddingRight: centerMode !== 'disabled' && centerModeSlidesGap ? centerModeSlidesGap / 2 : undefined,
	};

	return (
		<div
			className={`slide slide--${blockClass}  vtex-slider-layout-0-x-slide--${blockClass} vtex-slider-layout-0-x-slide vtex-slider-layout-0-x-slide--${blockClass} vtex-slider-layout-0-x-slide--firstVisible vtex-slider-layout-0-x-slide--${blockClass}--firstVisible vtex-slider-layout-0-x-slide--hidden vtex-slider-layout-0-x-slide--${blockClass}--hidden flex relative`}
			style={slideContainerStyles}
		>
			{children}
		</div>
	);
};

export default Slide;
